module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2018/september-76fa2d8d31f2aa99b9bfa6537cd45b7f.png";